import React, { useRef, useEffect } from 'react';
import 'aframe';
import '../primitives/hotspot';
import { customGaEvent, GA_EVENTS } from '../../../utils/ga';

import AframeIcon from '../components/AframeIcon';
import AframeTitle from '../components/AframeTitle';

const LinkHotspot = ({
  active,
  changeStop,
  darkMode,
  handlePlay,
  history,
  hotspotId,
  isBeingEdited,
  isDisabled,
  linkType,
  onClick,
  playing,
  position,
  rotation,
  showLabel,
  stopId,
  stopNum,
  title,
  tourId,
  tourName,
  hidden,
  url,
  value,
  hideGlow,
  iconSize,
  icon,
  iconSrc,
}) => {
  const titleId = showLabel ? `title_${hotspotId}` : null;
  const iconId = `icon_${hotspotId}`;
  const isLink = linkType === 'link';
  const srcId = '#hotspot__link-icon';
  const iconRef = useRef();
  const customAssetId = `custom-asset_${hotspotId}`;
  const customIconId = `custom-icon_${hotspotId}`;
  const focusId = `focus-outline_${hotspotId}`;
  const useCustomIcon = icon && iconSrc;

  useEffect(() => {
    const icon = iconRef.current;

    const handleClick = () => {
      onClick(hotspotId, isDisabled, true);

      if (typeof handlePlay === 'function' && playing) {
        handlePlay();
      }

      customGaEvent({
        action: GA_EVENTS.HOTSPOT_LINK_EXTERNAL,
        label: title,
      });
      window.open(url, '_blank', 'noreferrer');
    };
    icon && icon.addEventListener('click', handleClick);
    return () => {
      icon && icon.removeEventListener('click', handleClick);
    };
  }, [
    iconRef,
    playing,
    history,
    changeStop,
    handlePlay,
    isLink,
    url,
    tourId,
    tourName,
    title,
    onClick,
    hotspotId,
    isDisabled,
    value,
    stopId,
    stopNum,
  ]);

  return (
    <a-entity rotation={rotation}>
      <a-hotspot
        darkmode={darkMode}
        underedits={isBeingEdited}
        disabled={isDisabled}
        visible={!hidden}
        position={position}
        icon={useCustomIcon ? customIconId : iconId}
        title={titleId}
        id={`hotspot_${hotspotId}`}
        active={active}
        tourId={tourId}
        tourName={tourName}
        hotspotName={title}
        type={'link'}
        data-testid={`hotspot_${hotspotId}`}
        data-cy={`hotspot_${hotspotId}`}
        focusoutlineicon={focusId}
      >
        {showLabel && (
          <AframeTitle
            id={titleId}
            title={title}
            darkMode={darkMode}
            iconSize={iconSize}
            data-testid={titleId}
          />
        )}
        <AframeIcon
          focusId={focusId}
          src={
            icon ? `#${customAssetId}` : `${srcId}${darkMode ? '-black' : ''}`
          }
          id={icon ? customIconId : iconId}
          forwardRef={iconRef}
          hideGlow={hideGlow}
          iconSize={iconSize}
          data-testid={icon ? customIconId : iconId}
        />
        {useCustomIcon && (
          <a-asset>
            <img
              src={iconSrc}
              id={customAssetId}
              data-testid={customAssetId}
              crossOrigin="anonymous"
              alt=""
            />
          </a-asset>
        )}
      </a-hotspot>
    </a-entity>
  );
};

export default LinkHotspot;
